import { render, staticRenderFns } from "./inflowBatch.vue?vue&type=template&id=ce757ce6&scoped=true"
import script from "./inflowBatch.vue?vue&type=script&lang=js"
export * from "./inflowBatch.vue?vue&type=script&lang=js"
import style0 from "./inflowBatch.vue?vue&type=style&index=0&id=ce757ce6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce757ce6",
  null
  
)

export default component.exports